export const LOCALES = ["en", "ru"]